import { VHeaders } from '@/models/pagedlistmodel';

export function getAttachmentHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'attachmentTypes.attachmentTypeGridHeaders.name'
      ) as string,
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'attachmentTypes.attachmentTypeGridHeaders.description'
      ) as string,
      align: 'left',
      value: 'description',
      sortable: true,
    },
    {
      text: vm.$parent.$t(
        'attachmentTypes.attachmentTypeGridHeaders.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
}
